import React, {useEffect, useState} from 'react';
import classNames from 'classnames';
import Tab from 'react-bootstrap/Tab';
import Nav from 'react-bootstrap/Nav';
import {v4 as guid} from 'uuid';
import styles from './styles.module.scss';
import Empty from "../Empty";

const Tabs = ({items = [], containerClassnames = '', defaultTab}) => {
  const id = guid();
  const initialTab = defaultTab ? defaultTab : items[0]?.key;
  const [activeTab, setActiveTab] = useState(initialTab);

  useEffect(() => {
    if (defaultTab) {
      setActiveTab(defaultTab);
    }
  }, [defaultTab]);

  const renderTabs = items => {
    return items.map(item => {
      const {key, title, icon, disabled} = item;
      return (
        <Nav.Item key={key}>
          <Nav.Link
            eventKey={key}
            href="#"
            className={classNames(styles.tab, {[styles.active]: activeTab == key})}
            disabled={disabled}
          >
            {icon && (
              <span className={styles.icon}>
                {icon}
              </span>
            )}
            <span>{title}</span>
          </Nav.Link>
        </Nav.Item>
      );
    });
  };

  const renderContent = items => {
    return items.map(item => {
      const {key, content} = item;
      return (
        <Tab.Pane key={key} eventKey={key}>
          {content}
        </Tab.Pane>
      );
    });
  };

  return items.length > 0 ? (
    <Tab.Container
      id={id}
      defaultActiveKey={initialTab}
      activeKey={activeTab}
      onSelect={(k) => setActiveTab(k)}
    >
      <Nav variant="tabs" className={classNames(styles.tabsContainer, containerClassnames)}>
        {renderTabs(items)}
      </Nav>
      <Tab.Content className={classNames('flex-grow-1', styles.content)}>
        {renderContent(items)}
      </Tab.Content>
    </Tab.Container>
  ) : <Empty customContainerClassname={'pt-10'}/>;
};

export default Tabs;
